goog.provide('el8.apphome.layout');

goog.require('el8.app.pageLayout');


el8.apphome.layout = (function() {

    var PANE_CUSHION = 5;

    // Ref panel having min 250 and max 385
    var MAX_LHS_WIDTH = 385;
    var MIN_LHS_WIDTH = 250;

    // Ref panel and main pane split 30:70
    var LHS_SPLIT = 0.3;

    var that = {};

    that.lhsMaximized = false;

    that.setLHSMaximized = function(maximized) {
        that.lhsMaximized = maximized;
        that.updateAppLayout();
    };

    that.updateAppLayout = function() {
        var totalWidth = el8.app.pageLayout.getAppWidth();
        var refBoardWidth = Math.max(MIN_LHS_WIDTH,
            Math.min(LHS_SPLIT*totalWidth - 2*PANE_CUSHION, MAX_LHS_WIDTH))
            // adding 17 pixels here to compensate for the added ~17px of gutter
            // width in the new calendar's day view, so the width available for
            // events to fill stays roughly the same.
            + 17;

        if (that.lhsMaximized) {
            $('#refBoard').css('z-index', 100);
            $('#refBoard').css('position', 'absolute');
            // this min-width should match ".ebs-isolate .pageContainer" min-width
            $('#refBoard').css('min-width', '1024px');
            $('#refBoard').outerWidth('100%');
        } else {
            $('#refBoard').css('z-index', 0);
            $('#refBoard').css('position', '');
            $('#refBoard').css('min-width', '250px');
            $('#refBoard').outerWidth(refBoardWidth);
        }
        $('#main-content').css('margin-left', refBoardWidth);

        var innerHeight = el8.app.pageLayout.getAppInnerHeight();
        var refBoardHeight = $('#refBoardContainerB').outerHeight(true) || 0;
        var el8ShortcutBarHeight = $('.el8ShortcutBar').outerHeight(true) || 0;

        // Size up reference board panel (LHS) height
        $('#refBoardContainer').height(innerHeight - refBoardHeight);

        // Size up patient feed panel (RHS) height
        $("#patient-feed-container").height(innerHeight - el8ShortcutBarHeight);
    };

    that.setup = function() {
        that.updateAppLayout();

        // Bind as listener
        el8.app.pageLayout.addResizeListener(that.updateAppLayout);
    };

    return that;
})();
